<template>
  <div>
    <div class="p-3">
    <Create :patient-id="patientId"></Create>
    </div>
    <div class="p-3 mt-3">
      <LogCharts :patient-id="patientId"></LogCharts>
    </div>
  </div>
</template>
<script>
import Create from '@/components/Logs/Create'
import LogCharts from '@/components/Logs/Charts'
export default {
  components: {
    Create,
    LogCharts
  },
  props: {
    patientId: {
      type: String,
      required: true
    }
  }
}
</script>
